import { useAppSelector } from '@customer/store/hooks';
import { setMinSpeedLo } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MeasurementUnit } from '@customer/store/apis/authApi';
import NumberFilter from './NumberFilter';
import { ReactElement } from 'react';

export const MinSpeedLoFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicInputElement>): ReactElement => {
  const { t } = useTranslation();
  const units = useAppSelector(state => state.auth.units);

  return (
    <NumberFilter
      filterName="minSpeedLo"
      label={
        label ??
        t('minObjectSpeed', {
          obj: t('LO'),
          unit: t(units === MeasurementUnit.Metric ? 'unit.kmph' : 'unit.mph'),
        })
      }
      placeholder={t(units === MeasurementUnit.Metric ? 'speed.kmph' : 'speed.mph', { speed: 0 })}
      elementRef={elementRef}
      action={setMinSpeedLo}
    />
  );
};

export default MinSpeedLoFilter;
